// Ana api.js'den apiRequest fonksiyonunu import et
import { apiRequest } from './api';

export const createProject = async (projectData) => {
  try {
    return await apiRequest('/projects/create/', {
      method: 'POST',
      body: JSON.stringify(projectData),
    });
  } catch (error) {
    // Silently handle error
    throw error;
  }
};

export const updateProject = async (projectId, projectData) => {
  try {
    return await apiRequest(`/projects/${projectId}/update/`, {
      method: 'PUT',
      body: JSON.stringify(projectData),
    });
  } catch (error) {
    // Silently handle error
    throw error;
  }
};

export const getProjectsForTicketCreate = async (hotelId, departmentId) => {
  try {
    const params = new URLSearchParams({
      hotel_id: hotelId,
      department_id: departmentId
    });
    
    return await apiRequest(`/projects/ticketcreate/?${params}`, {
      method: 'GET',
    });
  } catch (error) {
    // Silently handle error
    throw error;
  }
};